import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const springApi = createApi({
    reducerPath: "core/spring",
    baseQuery: axiosBaseQuery,
    tagTypes: ["springList"],
    endpoints: (builder) => ({
        springFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['springList'],
            query: (query = '') => ({
                url: "/core/spring" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        springCreate: builder.mutation({
            invalidatesTags: ['springList'],
            query: (data) => ({
                url: `/core/spring`,
                method: "POST",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
        }),
        springUpdate: builder.mutation({
            invalidatesTags: ['springList'],
            // query: (data)=>({url: "/core/spring/"+data.id, method: "PUT", data})
            query: (data) => ({
                url: `/core/spring/${data.get('id')}`,
                method: "PUT",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                } 
            })
        }),

        springDelete: builder.mutation({
            invalidatesTags: ['springList'],
            query: (id) => ({ url: "/core/spring/" + id, method: "DELETE" })
        }),
    })
})

export const { useSpringFindAllQuery, useSpringCreateMutation, useSpringUpdateMutation, useSpringDeleteMutation } = springApi;
export { springApi };
